import './style.scss';

export function single_hero_block() {
    const block = document.querySelector('.single_hero_block');
    if (!block) return;

    const videoWrapper = block?.querySelector(".video-wrapper");
    if (!videoWrapper) return;

    const video = videoWrapper?.querySelector("video");
    const playBtn = videoWrapper?.querySelector(".video-button");
    const annotation = videoWrapper?.querySelector(".annotation");

    if (!video || !playBtn) return;

    // Hide controls on load
    video.controls = false;

    // When clicking play button
    playBtn.addEventListener("click", () => {
        video.play();
        playBtn.classList.remove("show-video-button");
        annotation?.classList.remove("show");
        video.controls = true;
    });

    // When video is paused manually
    video.addEventListener("pause", () => {
        playBtn.classList.add("show-video-button");
        annotation?.classList.add("show");
        video.controls = false;
    });

    // OPTIONAL: When video ends
    video.addEventListener("ended", () => {
        playBtn.classList.add("show-video-button");
        annotation?.classList.add("show");
        video.controls = false;
        video.currentTime = 0;
    });

}
